import * as i0 from "@angular/core";
var SessionStorageService = /** @class */ (function () {
    function SessionStorageService() {
    }
    /**
     * @param item item name
     * @param shouldRemove Flag to determine if it should be removed from storage after retrieving value
     * @returns parsed sessionStorage data or null value
     */
    SessionStorageService.prototype.getValue = function (item, shouldRemove) {
        if (shouldRemove === void 0) { shouldRemove = false; }
        var data = this.getItem(item);
        if (data && shouldRemove) {
            this.removeItem(item);
        }
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return null;
        }
    };
    /**
     * @param item item name
     * @param value object value stored as string
     */
    SessionStorageService.prototype.setValue = function (item, value) {
        this.setItem(item, JSON.stringify(value));
    };
    /**
     * Returns the session storage value
     * @param key The session storage key
     */
    SessionStorageService.prototype.getItem = function (key) {
        return sessionStorage.getItem(key);
    };
    /**
     * Persists and item in the session storage
     * @param key The session storage key
     * @param value The session storage value
     */
    SessionStorageService.prototype.setItem = function (key, value) {
        sessionStorage.setItem(key, value);
    };
    /**
     * Removes an item from the session storage
     * @param key The session storage key
     */
    SessionStorageService.prototype.removeItem = function (key) {
        sessionStorage.removeItem(key);
    };
    SessionStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SessionStorageService_Factory() { return new SessionStorageService(); }, token: SessionStorageService, providedIn: "root" });
    return SessionStorageService;
}());
export { SessionStorageService };
